import { useState, useEffect } from "react";
import { CohortService } from "@/services/cohortService";
import { useAuth } from "@/contexts/AuthContext";
import { Cohort } from "@/types/cohort";

/**
 * Hook to fetch the user's cohort.
 * If cohortId is provided, fetches that specific cohort (used when trainers join a course).
 * Otherwise, looks up the cohort by participant email.
 */
export const useUserCohort = (cohortId?: string) => {
  const [cohort, setCohort] = useState<Cohort | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const { currentUser } = useAuth();

  useEffect(() => {
    const fetchUserCohort = async () => {
      if (!currentUser?.email) {
        setLoading(false);
        return;
      }

      try {
        setLoading(true);
        setError(null);

        let userCohort: Cohort | null = null;

        if (cohortId) {
          // Direct cohort lookup (trainer joining a course)
          userCohort = await CohortService.getCohortById(cohortId);
        } else {
          // Lookup by participant email
          userCohort = await CohortService.getCohortByParticipantEmail(
            currentUser.email
          );
        }

        console.log("[useUserCohort] cohortId param:", cohortId, "result:", userCohort?.id, "name:", userCohort?.name);
        setCohort(userCohort);
      } catch (err) {
        console.error("Error fetching user cohort:", err);
        setError(err instanceof Error ? err.message : "Failed to fetch cohort");
      } finally {
        setLoading(false);
      }
    };

    fetchUserCohort();
  }, [currentUser?.email, cohortId]);

  return {
    cohort,
    loading,
    error,
  };
};
